//@flow
import reducer from "./reducers";

import * as tasksOperations from "./operations";
import * as tasksSelectors from "./selectors";

export { tasksOperations, tasksSelectors };

export default reducer;
